import React, { Component } from 'react';
import {
    Link, withRouter, useLocation
} from "react-router-dom";
import MenuComponent from './MenuComponent';
import UnAuthMenuComponent from './UnAuthMenuComponent';
import * as CookieService from '../CookieService';
let counter = 0;

const isReqApprovalEmail = (props) => {
    let isEmailLink = false;
    const routePath = props.location.pathname.toLowerCase();
    if (routePath.match(/approvequote/)) {
        isEmailLink = true;
        const reqqueryParams = new URLSearchParams(window.location.search);
        const reqQS_src = reqqueryParams.get('src');
        let reqSession_USERNAME = CookieService.getLocalStorageValues("Session_USERNAME") ? CookieService.getLocalStorageValues("Session_USERNAME") : "";
        if (reqQS_src) {
            if (reqQS_src.toLowerCase() == "needquote") {
                if (reqSession_USERNAME != "App Order Email Link" && reqSession_USERNAME != "App Quote Email Link") {
                    isEmailLink = false;
                }
            }
        }
    }
    return isEmailLink;
}

/*[08/22/22 , PC_07]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/

const isStkCartFromLink = (props) => {
    let isEmailLink = false;
    const routePath = props.location.pathname.toLowerCase();
    if (routePath.match(/stkissuescart/)) {
        const urlParams = window.location.search;
        let strurlParams = "";
        let qp = ""
        let mob_Session_USERID = ""
        let mob_Session_BUSUNIT = ""
        let Password = ""
        let isFromLink = false
        let Token = ""
        if (urlParams.includes("?qp_mob")) {
            strurlParams = urlParams.toString()
            let StrURL = strurlParams.split("?qp_mob=")
            let DecodedQueryparams = StrURL[1].toString();
            qp = atob(DecodedQueryparams);
            let QueryParams = qp.split("&")
            mob_Session_USERID = QueryParams[0].replace("mob_Session_USERID=", "");
            mob_Session_BUSUNIT = QueryParams[1].replace("mob_Session_BUSUNIT=", "");
            Password = QueryParams[2].replace("Password=", "");
            Token = QueryParams[3].replace("Token=", "");
            if (mob_Session_USERID || mob_Session_BUSUNIT || Token) {
                isEmailLink = true;
            }
        }
    }
    return isEmailLink;
}

/*[08/22/22 , PC_08]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
const isRMAFromLink = (props) => {
    let isEmailLink = false;
    const routePath = props.location.pathname.toLowerCase();
    if (routePath.match(/insiteonlinerma/)) {
        let strurlParams = "";
        let qp = ""
        let mob_Session_USERID = ""
        let mob_Session_BUSUNIT = ""
        let Token = ""
        let Password = ""
        /*[08/22/22 , PC_04]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
        const urlParams = window.location.search;
        if (urlParams.includes("?qp_mob")) {
            strurlParams = urlParams.toString()
            let StrURL = strurlParams.split("?qp_mob=")
            let DecodedQueryparams = StrURL[1].toString();
            qp = atob(DecodedQueryparams);
            let QueryParams = qp.split("&")
            mob_Session_USERID = QueryParams[0].replace("mob_Session_USERID=", "");
            mob_Session_BUSUNIT = QueryParams[1].replace("mob_Session_BUSUNIT=", "");
            Password = QueryParams[2].replace("Password=", "");
            Token = QueryParams[3].replace("Token=", "");
        }
        if (mob_Session_USERID && mob_Session_BUSUNIT && Token) {
            isEmailLink = true;
        }

    }
    return isEmailLink;
}

const isOrderApprovalLink = (props) => {
    let isEmailLink = false;
    const routePath = props.location.pathname.toLowerCase();
    if (routePath.match(/needapprove/)) {
        const orderQueryParams = new URLSearchParams(window.location.search);
        const orderQS_fer = orderQueryParams.get('fer');
        const orderQS_op = orderQueryParams.get('op');
        const orderQS_xyz = orderQueryParams.get('xyz');
        if (orderQS_fer || orderQS_op || orderQS_xyz) {
            isEmailLink = true;
        }

    }
    return isEmailLink;
}
const ComponentToShow = (props) => {
    let componentToBind = null;
    counter = counter + 1;
    console.log(counter);
    const locationVal = props.location;

    if (locationVal.pathname.toLowerCase().match(/forgotpassword/) || locationVal.pathname == "/" || locationVal.pathname.toLowerCase().match(/changepassword/) || locationVal.pathname.toLowerCase().match(/undermaintanance/)) {
        return componentToBind;
    }
    if (locationVal.pathname.toLowerCase().match(/sessiontimeout/) || locationVal.pathname.toLowerCase().match(/shopredirect/)) {
        componentToBind = (<UnAuthMenuComponent key={counter} {...props} />)
        return componentToBind;
    }
    let isOrderApprovalFromEmail = isOrderApprovalLink(props);
    let isReqApprovalFromEmail = isReqApprovalEmail(props);
    /*[08/22/22 , PC_09]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
    let isStkCartMob = isStkCartFromLink(props);
    let isRMAFromMob = isRMAFromLink(props)
    if (isOrderApprovalFromEmail || isReqApprovalFromEmail || isStkCartMob || isRMAFromMob) {
        componentToBind = <UnAuthMenuComponent key={counter} {...props} />
        return componentToBind;
    }

    componentToBind = <MenuComponent key={counter} {...props} />
    return componentToBind;
}

const HeaderComponent = withRouter(ComponentToShow);

export default HeaderComponent;